module.exports = __webpack_public_path__ + "1943ab51c3e28579acac7110242f7299.jpg";